import { Button } from "@chakra-ui/button";
import { useDisclosure } from "@chakra-ui/hooks";
import { Input } from "@chakra-ui/input";
import { Box, Text } from "@chakra-ui/layout";
import {
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
} from "@chakra-ui/menu";
import {
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
} from "@chakra-ui/modal";
import { Tooltip } from "@chakra-ui/tooltip";
import { BellIcon, ChevronDownIcon, SearchIcon } from "@chakra-ui/icons";
import { Avatar } from "@chakra-ui/avatar";
import { useHistory } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
import { useToast } from "@chakra-ui/toast";
import ChatLoading from "../ChatLoading";
import { Spinner } from "@chakra-ui/spinner";
import ProfileModal from "./ProfileModal";
import NotificationBadge from "react-notification-badge";
import { Effect } from "react-notification-badge";
import { getSender } from "../../config/ChatLogics";
import UserListItem from "../userAvatar/UserListItem";
import { ChatState } from "../../Context/ChatProvider";

function SideDrawer() {
  const [search, setSearch] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingChat, setLoadingChat] = useState(false);

  const {
    setSelectedChat,
    user,
    notification,
    setNotification,
    chats,
    setChats,
  } = ChatState();

  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const history = useHistory();

  const logoutHandler = () => {
    localStorage.removeItem("userInfo");
    history.push("/");
  };

  const handleSearch = async () => {
    if (!search) {
      toast({
        title: "Введите имя или почту",
        status: "warning",
        duration: 5000,
        isClosable: true,
        position: "top-left",
      });
      return;
    }

    try {
      setLoading(true);

      const config = {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      };

      const { data } = await axios.get(`/api/user?search=${search}`, config);

      setLoading(false);
      setSearchResult(data);
    } catch (error) {
      toast({
        title: "Ошибка",
        description: "Не удалось выполнить поиск",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom-left",
      });
    }
  };

  const accessChat = async (userId) => {
    try {
      setLoadingChat(true);
      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
      };
      const { data } = await axios.post(`/api/chat`, { userId }, config);

      if (!chats.find((c) => c._id === data._id)) setChats([data, ...chats]);
      setSelectedChat(data);
      setLoadingChat(false);
      onClose();
    } catch (error) {
      toast({
        title: "Не удалось открыть диалог",
        description: error.message,
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom-left",
      });
    }
  };

  return (
    <>
      <Box
        d="flex"
        justifyContent="space-between"
        alignItems="center"
        bg="#243D27"
        backgroundImage="linear-gradient(180deg, rgba(253,247,233,0.05) 0%, rgba(20,35,23,0.25) 100%)"
        color="#F2DFB6"
        w="100%"
        p="10px 18px"
        boxShadow="0 4px 18px rgba(20, 35, 23, 0.28)"
        position="relative"
        zIndex={5}
      >
        <Tooltip label="Найти художника" hasArrow placement="bottom-end">
          <Button
            variant="ghost"
            color="#F2DFB6"
            borderRadius="12px"
            _hover={{ bg: "rgba(242, 223, 182, 0.12)" }}
            _active={{ bg: "rgba(242, 223, 182, 0.2)" }}
            onClick={onOpen}
          >
            <SearchIcon boxSize="15px" />
            <Text
              d={{ base: "none", md: "flex" }}
              px={3}
              fontWeight={400}
              letterSpacing="0.03em"
            >
              Поиск
            </Text>
          </Button>
        </Tooltip>
        <Box d="flex" alignItems="baseline" userSelect="none">
          <Text
            className="atika-wordmark"
            fontSize="27px"
            color="#F2DFB6"
            lineHeight="1"
          >
            А.Т.И.К.А
          </Text>
          <Text
            fontFamily="'Prata', serif"
            fontSize="12px"
            color="#ECCFA7"
            letterSpacing="0.3em"
            ml={3}
            d={{ base: "none", sm: "block" }}
          >
            АРТ КЛУБ
          </Text>
        </Box>
        <Box d="flex" alignItems="center">
          <Menu>
            <MenuButton p={1} borderRadius="12px" mr={1}>
              <NotificationBadge
                count={notification.length}
                effect={Effect.SCALE}
              />
              <BellIcon fontSize="2xl" m={1} color="#F2DFB6" />
            </MenuButton>
            <MenuList>
              {!notification.length && (
                <Text px={4} py={1} fontSize="sm" opacity={0.7}>
                  Новых сообщений нет
                </Text>
              )}
              {notification.map((notif) => (
                <MenuItem
                  key={notif._id}
                  onClick={() => {
                    setSelectedChat(notif.chat);
                    setNotification(notification.filter((n) => n !== notif));
                  }}
                >
                  {notif.chat.isGroupChat
                    ? `Новое сообщение в «${notif.chat.chatName}»`
                    : `Новое сообщение от ${getSender(user, notif.chat.users)}`}
                </MenuItem>
              ))}
            </MenuList>
          </Menu>
          <Menu>
            <MenuButton
              as={Button}
              bg="transparent"
              borderRadius="12px"
              px={2}
              _hover={{ bg: "rgba(242, 223, 182, 0.12)" }}
              _active={{ bg: "rgba(242, 223, 182, 0.2)" }}
              rightIcon={<ChevronDownIcon color="#F2DFB6" />}
            >
              <Avatar
                size="sm"
                cursor="pointer"
                name={user.name}
                src={user.pic}
                border="2px solid rgba(242, 223, 182, 0.65)"
              />
            </MenuButton>
            <MenuList>
              <ProfileModal user={user}>
                <MenuItem>Мой профиль</MenuItem>{" "}
              </ProfileModal>
              {user.isAdmin && (
                <MenuItem onClick={() => history.push("/admin")}>
                  Админка
                </MenuItem>
              )}
              <MenuDivider borderColor="#E4D2A6" />
              <MenuItem onClick={logoutHandler} color="#8D414B">
                Выйти
              </MenuItem>
            </MenuList>
          </Menu>
        </Box>
      </Box>

      <Drawer placement="left" onClose={onClose} isOpen={isOpen}>
        <DrawerOverlay bg="rgba(20, 35, 23, 0.45)" />
        <DrawerContent bg="#FBF0D9">
          <DrawerHeader
            borderBottomWidth="1px"
            borderColor="#E4D2A6"
            fontFamily="'Prata', serif"
            fontSize="19px"
            color="#243D27"
          >
            Найти художника
          </DrawerHeader>
          <DrawerBody pt={4}>
            <Box d="flex" pb={4}>
              <Input
                placeholder="Имя или почта"
                mr={2}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleSearch()}
              />
              <Button
                colorScheme="burgundy"
                px={5}
                onClick={handleSearch}
                _hover={{ bg: "#7A3841", transform: "translateY(-1px)" }}
              >
                Найти
              </Button>
            </Box>
            {loading ? (
              <ChatLoading />
            ) : (
              searchResult?.map((user) => (
                <UserListItem
                  key={user._id}
                  user={user}
                  handleFunction={() => accessChat(user._id)}
                />
              ))
            )}
            {loadingChat && <Spinner ml="auto" d="flex" color="#8D414B" />}
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
}

export default SideDrawer;
